
<div class="file-uploader">
    <div class="file-uploader-content">
        <button mat-raised-button class="garantor-button mini upload-button" type="button" color="primary" (click)="fileInput.click()" [disabled]="disabled || !!document">
            {{ label }}
        </button>
        <span class="file-name" *ngIf="document?.nombreArchivo">
            {{ document.nombreArchivo }}
        </span>
        <button mat-icon-button class="delete-button" type="button" color="accent" [disabled]="disabled" *ngIf="document" (click)="deleteFile()">
            <mat-icon>delete</mat-icon>
        </button>
        <input #fileInput type="file" class="file-input" (change)="onFileUpload($event)">
    </div>
    <span class="error-message" *ngIf="requiredErrorMessage && control?.touched && control?.hasError('required')">
        {{ requiredErrorMessage }}
    </span>
    <span class="hint" *ngIf="hint && !(requiredErrorMessage && control?.touched && control?.hasError('required'))">
        {{ hint }}
    </span>
</div>
